import { InventoryTransferCreateDTO } from "../../../types/inventory/transfer/InventoryTransferTypes";

export const validateInventoryTransferForm = (
  form: InventoryTransferCreateDTO
): Record<string, string> => {
  const errors: Record<string, string> = {};

  // 🔹 Sucursal Destino
  if (!form.destinationBranchId) {
    errors.destinationBranchId = "Seleccione sucursal destino";
  }

  // 🔹 Validar que no sean iguales
  if (
    form.originBranchId &&
    form.destinationBranchId &&
    Number(form.originBranchId) === Number(form.destinationBranchId)
  ) {
    errors.destinationBranchId = "El origen y destino no pueden ser iguales";
  }

  return errors;
};
